import actions from "./actions";

const initState = {
  data: null,
  file: null,
  doe: null,
  doeLogo: null,
  doeUrl: null,
  loading: false,
  successStatus: "",
  formFields: [],
  adminSettings: [],
  schools: null,
};

export default function importReducer(state = initState, action) {
  switch (action.type) {
    case actions.IMPORT_SUCCESS:
      return { ...state, data: action.data };

    case actions.ENCRYPT_DONE:
      return { ...state, file: action.file };

    case actions.SET_DEO_DONE:
    case actions.FETCH_DOE_DONE:
      return { ...state, doe: action.doe };

    case actions.RESET:
      return {
        ...state,
        data: null,
        file: null,
        doeLogo: null,
        doeUrl: null,
      };

    case actions.FETCH_CONFIGS_SUCCESS:
      return { ...state, schools: action.schools };

    case actions.UPDATE_SETTINGS:
      return { ...state, loading: true, successStatus: false };

    case actions.FETCH_FIELDS_RESULT:
      return { ...state, formFields: action.payload, loading: false };

    case actions.FETCH_ADMIN_SETTINGS_SUCCESS:
      return { ...state, adminSettings: action.payload, loading: false };

    case actions.FETCH_FIELDS:
      return { ...state, loading: true };

    default:
      return state;
  }
}
